import { render, staticRenderFns } from "./SupsisBadge.vue?vue&type=template&id=60a02155&scoped=true"
import script from "./SupsisBadge.vue?vue&type=script&lang=js"
export * from "./SupsisBadge.vue?vue&type=script&lang=js"
import style0 from "./SupsisBadge.vue?vue&type=style&index=0&id=60a02155&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a02155",
  null
  
)

export default component.exports